import * as endpoints from '../helpers/endpoints';
import * as types from './action-types';
import apiRequest from '../helpers/apiRequest';

import { unAuthUser } from './index';

export const fetchUserInfo = () => {
    return {
        type: types.FETCH_USER_INFO
    };
};

export const fetchUserInfoSuccess = userInfo => {
    return {
        type: types.FETCH_USER_INFO_SUCCESS,
        userInfo
    };
};

export const fetchUserInfoThunk = () => (dispatch, getState) => {
    dispatch(fetchUserInfo());
    apiRequest(`${endpoints.USER_INFO_PATH}`, getState().auth.jwtToken)
        .then(payload => {
            dispatch(
                badgeCount(
                    payload.data.id,
                    payload.data.TrustingUser && payload.data.TrustingUser.id,
                    payload.data.MappedUsername.lastLogin
                )
            );
            dispatch(fetchUserInfoSuccess(payload.data));
        })
        .catch(error => {
            console.log(error);
            dispatch(unAuthUser());
        });
};

export const userEvents = id => (dispatch, getState) => {
    if (id !== undefined) {
        return apiRequest(
            `${endpoints.EMS}user/${id}/all`,
            getState().auth.jwtToken
        )
            .then(response => {
                return Promise.resolve(response.data);
            })
            .catch(err => Promise.reject(err));
    } else {
        return Promise.resolve({ events: [], reports: [], tasks: [] });
    }
};

export const badgeCount = (id, trustedUserId, lastLogin) => (
    dispatch,
    getState
) => {
    return Promise.all([
        dispatch(userEvents(id)),
        dispatch(userEvents(trustedUserId))
    ])
        .then(values => {
            let masterObj = {
                events: [...values[0].events, ...values[1].events],
                reports: [...values[0].reports, ...values[1].reports],
                tasks: [...values[0].tasks, ...values[1].tasks]
            };
            const count = Object.keys(masterObj).reduce((acc, val) => {
                let count = masterObj[val].filter(item => {
                    return item.updatedAt > lastLogin;
                }).length;
                return acc + count;
            }, 0);
            dispatch(badgeCountSuccess(count));
        })
        .catch(err => {
            console.log(err);
            return Promise.reject(err);
        });
};

export const badgeCountSuccess = count => {
    return {
        type: types.BADGE_COUNT_SUCCESS,
        count
    };
};



// WEBPACK FOOTER //
// ./src/actions/user-info.js